module.exports = __webpack_public_path__ + "img/jdwi1.a9bfcaa9.webp";